import { render, staticRenderFns } from "./ChangeSim.vue?vue&type=template&id=038afd03&scoped=true&"
import script from "./ChangeSim.vue?vue&type=script&lang=js&"
export * from "./ChangeSim.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSim.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChangeSim.vue?vue&type=style&index=1&id=038afd03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038afd03",
  null
  
)

export default component.exports